import {DELETE_SUCCESS} from "../../../reducers/robotsAndVehiclesReducer";


export const deleteSuccess = (robot, vehicle) =>{
    return {
        type: DELETE_SUCCESS,
        payload: {robot, vehicle}
    }
}